import * as CryptoJS from 'crypto-js'
import TagManager from 'react-gtm-module'

export class GoogleTags {
  public googleAnalyticsId: string
  public googleOptimizeId: string
  public googleTagManagerId: string
  private promise?: Promise<any>
  private dataLayer?: any

  constructor(
    googleAnalyticsId: string,
    googleOptimizeId: string,
    googleTagManagerId: string,
  ) {
    this.googleAnalyticsId = googleAnalyticsId
    this.googleOptimizeId = googleOptimizeId
    this.googleTagManagerId = googleTagManagerId
  }

  public pageView(eventName: string, params: object) {
    return new Promise<void>((resolve, reject) => {
      this._load()
        .then(() => {
          this.gtag('config', this.googleAnalyticsId, {
            page_title: document.title,
            page_path: window.location.pathname,
          })
          resolve()
        })
        .catch(err => {
          console.error('Error loading Google Tag Manager')
          reject(err)
        })
    })
  }

  public identify(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          if (data.email !== undefined) {
            const email = CryptoJS.SHA256(data.email.toLowerCase().trim())
              .toString()
              .substr(0, 32)
            this.gtag('config', this.googleAnalyticsId, {
              user_id: email,
            })
            resolve({ user_id: email })
          }
          resolve('No email present')
        })
        .catch(err => {
          console.error('Error loading Google Tag Manager')
          reject(err)
        })
    })
  }

  public track(eventName: string, params: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          if (
            eventName === 'begin_checkout' ||
            eventName === 'checkout_progress'
          ) {
            this.gtag('event', eventName, params)
            resolve({
              eventName,
              params,
            })
          } else if (eventName === 'custom_action') {
            this.gtag('event', params.event_action, params)
            resolve({
              action: params.event_action,
              params,
            })
          } else {
            const gParams = {
              event_category: params.event_category
                ? params.event_category
                : 'ecommerce',
              ...params,
            }

            this.gtag('event', eventName, gParams)
            resolve({
              eventName,
              params: gParams,
            })
          }
        })
        .catch(err => {
          console.error('Error loading Google Tag Manager')
          reject(err)
        })
    })
  }

  private gtag(name: string, params: any, params2?: any) {
    this.dataLayer.push(arguments)
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise<void>((resolve, reject) => {
        if (this.dataLayer) {
          resolve()
        } else {
          const gaScript = document.createElement('script')
          const getDataLayer = () =>
            ((window as any).dataLayer = (window as any).dataLayer || [])

          if (TagManager) {
            TagManager.initialize({
              gtmId: this.googleTagManagerId,
              dataLayer: getDataLayer(),
            })
          }

          gaScript.onload = () => {
            this.dataLayer = getDataLayer()
            this.gtag('js', new Date())
            this.gtag('config', this.googleAnalyticsId, {
              optimize_id: this.googleOptimizeId,
            })
            resolve()
          }

          gaScript.onerror = error => {
            reject(error)
          }

          gaScript.src = `https://www.googletagmanager.com/gtag/js?id=${this.googleAnalyticsId}`
          document.head.appendChild(gaScript)
        }
      }))
    )
  }
}
